import {
  Heading,
  Modal,
  ModalBody,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Text,
  VStack,
  Button,
  Center,
  useDisclosure,
  Spacer,
  ModalCloseButton,
  Image,
  ButtonGroup,
} from '@chakra-ui/react';
import { useContext, useState } from 'react';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { AccountContext } from '../../../AccountContext';
import { api } from 'api/api';

import Simulacao from '../../../../images/modalPsicologo.svg';

const ENDPOINT =
  process.env.REACT_APP_ENVIRONMENT === 'production'
    ? process.env.REACT_APP_BASE_URL_API_SERVER_PROD
    : process.env.REACT_APP_BASE_URL_API_SERVER_TEST;

function AvisoDependente(props) {
  const disclosure = props.disclosure;
  const { user, setUser } = useContext(AccountContext);
  const navigate = useNavigate();
  /*const [dependentes, setDependentes] = useState([]);
  const url = `${ENDPOINT}/client/dependents-no-cpf`;
  const payload = {
    id_contrato: user.id_contrato,
  };
  const fetchPosts = async () => {
    const response = await api(url, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      method: 'POST',
      body: JSON.stringify(payload),
    });
    await response.json().then(async function (postsData) {
      setDependentes(postsData.data);
      if (postsData.data && postsData.data.length > 0) {
        disclosure.onOpen();
      }
    });
  };
  useEffect(() => {
    if (!user.aviso_dependentes && user.id_contrato && user.id_contrato !== 0) {
      fetchPosts();
    }
  }, []);*/

  return (
    <>
      <Modal isOpen={disclosure.isOpen} isCentered>
        <ModalOverlay />
        <ModalContent maxW="95%" h="auto" borderRadius="0.8em">
          <ModalCloseButton mt={1} color={'#9E9E9E'} onClick={() => disclosure.onClose()} _focus={false} />
          <ModalBody mb={4}>
            <VStack align={'left'} borderBottom={'0.1px black'}>
              <Text color={'#9E9E9E'} mt={2}>
                Atualizar dados
              </Text>
            </VStack>
            <Spacer border={'0.1px solid #f0f0f0'} />
            <VStack>
              <Image src={Simulacao} mt={4} w={'60%'} />
              <Text color={'#616161'} fontWeight={'bold'} fontSize={'1.5em'} lineHeight={'1.2em'} textAlign={'center'}>
                Não deixe ninguém de fora!
              </Text>

              <Text color={'#616161'} textAlign={'center'} fontSize={'17px'} letterSpacing={'-0.07em'}>
                Atualize agora as informações dos seus dependentes para garantir que eles continuem aproveitando todos os benefícios da sua assinatura
                DeoVita.
              </Text>

              <ButtonGroup mb={2}>
                <Button
                  border={'1px solid #9E9E9E'}
                  variant="outline"
                  borderRadius={'0.8em'}
                  fontWeight="bold"
                  isFullWidth
                  color={'#9E9E9E'}
                  onClick={(e) => {
                    disclosure.onClose();
                    setUser((prevState) => ({
                      ...prevState,
                      aviso_dependentes: true,
                    }));
                  }}
                >
                  Atualizar depois
                </Button>

                <Button
                  bg="#5AB2AE"
                  isFullWidth
                  borderColor="blue.500"
                  borderRadius={'0.8em'}
                  fontWeight="bold"
                  color={'white'}
                  onClick={() => {
                    disclosure.onClose();
                    setUser((prevState) => ({
                      ...prevState,
                      aviso_dependentes: true,
                    }));
                    navigate('/perfil/dependentes/');
                  }}
                >
                  Atualizar agora!
                </Button>
              </ButtonGroup>
            </VStack>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
}

export default AvisoDependente;